module.exports = __webpack_public_path__ + "img/25.1661b1c.jpg";